







































import Vue from "vue";
import { mapState } from "vuex";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";
import FreeTrialList from "../components/billing/freeTrial-list.vue";

export default Vue.extend({
  components: { BottomNavigation, BottomNavigationItem, FreeTrialList },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      currentMenuItemName: "lists",
      showCancelAccount: false,
      showPlanSelector: false,
    };
  },
  computed: {
    ...mapState("billing", ["loading"]),
    pageTitle() {
      let title = "";
      switch (this.currentMenuItemName) {
        case "lists":
          title = "Free Trials";
          break;
        case "progress":
          title = "Progress";
          break;
      }

      return title;
    },
  },
  mounted() {
    this.$Notice.config({
      top: 120,
      duration: 3,
    });

    this.loadFreeTrialAccounts();
  },
  beforeDestroy() {},
  methods: {
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      //this.$store.dispatch("goal/setActiveMenu", name);

      //if (this.lastMenuItemName === "checkins" && (this as any).currentGoalHasCheckpointUpdated === true) {
      //  this.loadGoal();
      //}
      //this.lastMenuItemName = name;
    },
    loadFreeTrialAccounts() {
      let context = this as any;
      this.$store
        .dispatch("billing/getFreeTrials")
        .then((response) => {})
        .finally(() => {});
    },
  },
});
